import { NgModule } from "@angular/core";
import { SharedApiKno2fyMainModule } from "../api-kno2fy-main";

@NgModule({
    imports: [SharedApiKno2fyMainModule]
})
export class DesktopDataAccessApiDesktopModule {}
